import { TeamMember } from '../team-member.model';

export class LoadTeamMembers {
  static readonly type = '[Team Members] Load';
  constructor(public page = 0, public pageSize = 10) {}
}

export class LoadTeamMembersSuccess {
  static readonly type = '[Team Members] Load Success';
  constructor(public teamMembers: TeamMember[], public total: number) {}
}

export class LoadTeamMembersFailure {
  static readonly type = '[Team Members] Load Failure';
  constructor(public error: Error) {}
}

export class SetTeamMembersPage {
  static readonly type = '[Team Members] Set Page';
  constructor(public page: number) {}
}

export class SetTeamMembersPageSize {
  static readonly type = '[Team Members] Set Page Size';
  constructor(public pageSize: number) {}
}
